import { useEffect, useState } from "react";
import { useStore, useStoreApi } from '@hmpu/powerups.store';
import { useVieConfig } from '@hmpu/powerups.vie.hooks.use-vie-config';

export const Replay = (props) => {
  const { goToPage } = useVieConfig();

  // const gameLevel = useStore((state) => state.gameLevel);
  // const setGameLevel = useStore((state) => state.setGameLevel);

  useEffect(() => {
    // setCharacterSelected(null);
    // setGameLevel(null);

    // window.dispatchEvent(
    //     new CustomEvent("endAction", {
    //         detail: {
    //             replay: true,
    //             reload: false
    //         }
    //     }
    //   ));

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('skipTo','GAMEPLAY');
    window.history.replaceState(null, null, '?' + urlParams.toString());
    setTimeout(() => {
      goToPage('GAME_PLAY');
    }, 100);

  }, []);

  return (
    <>
    </>
  );
};

export default Replay;
